package com.vizio.redwolf.utils

import com.vizio.redwolf.utils.model.MobileHeaderInfo
import io.ktor.client.plugins.timeout
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.header
import io.ktor.client.request.headers
import io.ktor.http.HttpHeaders


const val SCHEME_HTTPS = "https"
const val CONTENT_TYPE_APP_JSON_UTF8 = "application/json; charset=utf-8"
const val ACCEPT_TYPE_APP_JSON = "application/json"
const val HEADER_TRACE_ID = "x-viz-trace-id"
const val HEADER_SENTRY_TRACE = "sentry-trace"
const val HEADER_TV_APP_ID = "tv-app-id"
const val HEADER_MOBILE_DEVICE_ID = "mdid"
const val HEADER_MOBILE_OS_VERSION = "mos"
const val HEADER_TRANSACTION_ID = "mtid"
const val HEADER_MOBILE_USER_AGENT = "muser-agent"
const val HEADER_APP_VERSION = "app-version"
const val HEADER_MOBILE_DEVICE_MODEL = "mdmodel"
const val HEADER_MOBILE_DEVICE_TYPE = "mdtype"

fun HttpRequestBuilder.applyUserBearerToken(authToken: String) {
    if (authToken.isNotEmpty()) {
        headers {
            append(HttpHeaders.Authorization, "Bearer $authToken")
        }
    } else {
        //TODO: Replace it with Sentry logger. RED-3094: Removed Kermit logger
        //SDKLogger().log("Skipping authorization header due to empty auth token.")
    }
}

fun HttpRequestBuilder.setTraceId(traceId: String?) {
    traceId?.let { header(HEADER_TRACE_ID, it) }
}

fun HttpRequestBuilder.applyTimeout(timeout: Long) {
    timeout {
        requestTimeoutMillis = timeout
    }
}

fun HttpRequestBuilder.setSentryHeader(sentryHeader: String?) {
    sentryHeader?.let { header(HEADER_SENTRY_TRACE, it) }
}

fun HttpRequestBuilder.setTvAppId(tvAppId: String?) {
    tvAppId?.let { header(HEADER_TV_APP_ID, it) }
}

fun HttpRequestBuilder.setDebugInfo(mobileHeaderInfo: MobileHeaderInfo?) {
    headers {
        if (mobileHeaderInfo != null) {
            append(HEADER_APP_VERSION, mobileHeaderInfo.appVersion)
            append(HEADER_MOBILE_DEVICE_ID, mobileHeaderInfo.mobileDeviceId)
            append(HEADER_MOBILE_OS_VERSION, mobileHeaderInfo.mobileOsVersion)
            append(HEADER_MOBILE_USER_AGENT, mobileHeaderInfo.mobileUserAgent)
            append(HEADER_MOBILE_DEVICE_MODEL, mobileHeaderInfo.mobileDeviceModel)
            append(HEADER_MOBILE_DEVICE_TYPE, mobileHeaderInfo.mobileDeviceType)
            mobileHeaderInfo.transactionId?.let { transactionId ->
                append(HEADER_TRANSACTION_ID, transactionId)
            }
            mobileHeaderInfo.customParams?.forEach { item ->
                append(item.key, item.value)
            }
        }
    }
}

fun HttpRequestBuilder.buildHttpRequest(): HttpRequestInfo {
    return HttpRequestInfo(
        url = this.url.toString(),
        method = this.method.toString(),
        requestBody = this.body.toString(),
        requestHeaders = this.headers.toString()
    )
}